module.exports = __webpack_public_path__ + "static/media/bookmark-svgrepo-com (1).6582e22d.svg";